__turbopack_context__.v({
  "cartDetails": "CartModal-module__W96bUG__cartDetails",
  "checkoutBtn": "CartModal-module__W96bUG__checkoutBtn",
  "content": "CartModal-module__W96bUG__content",
  "continueShoppingBtn": "CartModal-module__W96bUG__continueShoppingBtn",
  "footer": "CartModal-module__W96bUG__footer",
  "main": "CartModal-module__W96bUG__main",
});
